import axios from 'axios'
import router from '@/router'
import { buildRequestBody } from '@/helpers/lists'

const fetchZones = async ({ commit, rootState, dispatch }, payload) => {
  await axios.get(`${rootState.baseURL}/properties/${payload.id}/activityzones`, {
  })
    .then((res) => {
      if (res) {
        commit('updateZones', res.data.data)
      }
    })
}

const updateThresholdsForActivityZone = async ({ commit, dispatch, rootState }, { activityZoneID, payload }) => {
  return axios.put(`${rootState.baseURL}/thresholds/activityZone/${activityZoneID}/replace`, payload)
}

const fetchAZList = ({ rootState, commit }, payload) => {
  commit('setLoadingState', true, { root: true })
  commit('resetAZList')
  const requestBody = buildRequestBody(payload)
  axios.post(`${rootState.baseURL}/activityzones/list`, requestBody, {
  })
    .then((res) => {
      if (res) {
        commit('updateAZListData', res.data.data)
        commit('updateAZPagination', res.data.pagination)
        commit('setLoadingState', false, { root: true })
      }
    })
}

const deleteZone = async ({ rootState, dispatch }, payload) => {
  await axios.delete(`${rootState.baseURL}/activityzones/${payload.id}`)
    .then((res) => {
      if (res) {
        const toastPayload = { type: 'success', text: 'Successfully deleted zone' }
        dispatch('updateMessages', toastPayload, { root: true })
        router.push({ path: payload.path })
      }
    })
}

const updateZone = async ({ rootState, dispatch }, payload) => {
  return axios.put(`${rootState.baseURL}/activityzones/${payload.id}`, {
    name: payload.name,
  })
}

const fetchSignalStrengths = ({ rootState, commit }, propertyId) => {
  const payload = {
    filter: [{ key: 'property_id', operator: '=', value: propertyId }],
    pagination: { perPage: 999, pageNum: 1 },
  }
  return axios.post(`${rootState.baseURL}/activityzones/signalStrength/list`, payload, {})
    .then((res) => {
      if (res) {
        commit('updateSignalStrengths', res.data.data)
      }
    })
}

export default {
  fetchZones,
  updateThresholdsForActivityZone,
  fetchAZList,
  deleteZone,
  updateZone,
  fetchSignalStrengths,
}
